import Component from '@glimmer/component';

// eslint-disable-next-line ember/no-empty-glimmer-component-classes
export default class lfGetOutletStateComponent extends Component {}
